module.exports = __webpack_public_path__ + "media/images/icons/info_green-5cbf064ff6fe7c48e2119bb7732c41ff.png";